(function () {
  'use strict';

  var SELECTORS = {
    searchDetails: 'details[id*="search"], details.search, details.header__search',
    searchToggle: '[aria-controls*="search"], .search-toggle, .header__search-toggle, details.header__search > summary',
    searchInput: 'input[type="search"], input[name="q"], .search__input, .predictive-search__input',
    predictiveDropdown: 'predictive-search, .predictive-search, #predictive-search-results, [id*="predictive-search"]',
    searchForm: '.search-modal, .search-form, form[action*="/search"]',
  };

  var INIT_ATTR = 'data-a11y-search-fixed';

  function isMarked(el) {
    return el.hasAttribute(INIT_ATTR);
  }

  function markEl(el) {
    el.setAttribute(INIT_ATTR, 'true');
  }

  function isExpanded(el) {
    if (el.tagName === 'DETAILS') return el.hasAttribute('open');
    var ariaExp = el.getAttribute('aria-expanded');
    if (ariaExp !== null) return ariaExp === 'true';
    return false;
  }

  function expandEl(el) {
    if (el.tagName === 'DETAILS') {
      el.setAttribute('open', '');
    } else {
      el.setAttribute('aria-expanded', 'true');
    }
  }

  function collapseEl(el) {
    if (el.tagName === 'DETAILS') {
      el.removeAttribute('open');
    } else {
      el.setAttribute('aria-expanded', 'false');
    }
  }

  function getPredictiveDropdown(inputEl) {
    var form = inputEl.closest('form');
    if (form) {
      var dropdown = form.querySelector(SELECTORS.predictiveDropdown)
        || form.parentElement && form.parentElement.querySelector(SELECTORS.predictiveDropdown);
      if (dropdown) return dropdown;
    }
    var searchContainer = inputEl.closest(
      'details, .search-modal, .search-modal__content, [class*="search"]'
    );
    if (searchContainer) {
      return searchContainer.querySelector(SELECTORS.predictiveDropdown);
    }
    return document.querySelector(SELECTORS.predictiveDropdown);
  }

  function showDropdown(dropdown) {
    if (!dropdown) return;
    dropdown.removeAttribute('hidden');
    dropdown.setAttribute('aria-hidden', 'false');
    dropdown.style.display = '';
  }

  function hideDropdown(dropdown) {
    if (!dropdown) return;
    var isEmpty = !dropdown.textContent.trim() ||
      dropdown.querySelectorAll('li, a, [role="option"]').length === 0;
    if (isEmpty) {
      dropdown.setAttribute('hidden', '');
      dropdown.setAttribute('aria-hidden', 'true');
    }
  }

  function patchSearchInput(inputEl) {
    if (isMarked(inputEl)) return;
    markEl(inputEl);

    var dropdown = getPredictiveDropdown(inputEl);

    inputEl.removeAttribute('autofocus');

    inputEl.addEventListener('focus', function (e) {
      e.stopPropagation();
    }, true);

    if (dropdown) {

      var origFocusDescriptor = null;
      var proto = Object.getPrototypeOf(inputEl);
      while (proto && proto !== HTMLElement.prototype) {
        var desc = Object.getOwnPropertyDescriptor(proto, 'onfocus');
        if (desc) { origFocusDescriptor = desc; break; }
        proto = Object.getPrototypeOf(proto);
      }

      inputEl.addEventListener('input', function () {
        if (inputEl.value.trim().length > 0) {
          showDropdown(dropdown);
        } else {
          hideDropdown(dropdown);
        }
      });

      inputEl.addEventListener('blur', function () {
        setTimeout(function () {
          var active = document.activeElement;
          var insideDropdown = dropdown && dropdown.contains(active);
          var insideForm = inputEl.form && inputEl.form.contains(active);
          if (!insideDropdown && !insideForm) {
            hideDropdown(dropdown);
          }
        }, 150);
      });

      if (dropdown.querySelectorAll('li, a, [role="option"]').length === 0) {
        dropdown.setAttribute('hidden', '');
        dropdown.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function patchDetailsSearch(detailsEl) {
    if (isMarked(detailsEl)) return;
    markEl(detailsEl);

    var summary = detailsEl.querySelector('summary');
    if (!summary) return;

    summary.setAttribute('aria-expanded', detailsEl.hasAttribute('open') ? 'true' : 'false');
    if (!summary.getAttribute('aria-controls')) {
      var inner = detailsEl.querySelector('.search-modal, .search-form, form, [id]');
      if (inner) {
        if (!inner.id) inner.id = 'search-panel-' + Math.random().toString(36).slice(2, 7);
        summary.setAttribute('aria-controls', inner.id);
      }
    }

    summary.addEventListener('click', function () {
      var willOpen = !detailsEl.hasAttribute('open');
      summary.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    var focusInHandler = function (e) {
      var target = e.target || e.srcElement;
      if (summary.contains(target)) return;
      if (!isExpanded(detailsEl)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    };

    detailsEl.addEventListener('focusin', focusInHandler, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isExpanded(detailsEl)) {
        collapseEl(detailsEl);
        summary.setAttribute('aria-expanded', 'false');
        summary.focus();
      }
    });
  }

  function patchNativeCustomElement(ceEl) {
    if (isMarked(ceEl)) return;
    markEl(ceEl);

    var input = ceEl.querySelector(SELECTORS.searchInput);
    if (input) patchSearchInput(input);

    var open = ceEl.open;
    var close = ceEl.close;

    if (typeof ceEl.open === 'function') {
      ceEl.open = function () {
        return open.apply(this, arguments);
      };
    }

    if (typeof ceEl.close === 'function') {
      ceEl.close = function () {
        var result = close.apply(this, arguments);
        var inp = this.querySelector(SELECTORS.searchInput);
        if (inp) {
          var dd = getPredictiveDropdown(inp);
          if (dd) hideDropdown(dd);
        }
        return result;
      };
    }
  }

  function interceptFocusExpansion() {
    var style = document.createElement('style');
    style.id = 'a11y-search-focus-fix';
    style.textContent = [
      'details.header__search:not([open]) .search-modal,',
      'details[id*="search"]:not([open]) > *:not(summary) {',
      '  visibility: hidden;',
      '  pointer-events: none;',
      '}',
      'details.header__search[open] .search-modal,',
      'details[id*="search"][open] > *:not(summary) {',
      '  visibility: visible;',
      '  pointer-events: auto;',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function processAll() {
    document.querySelectorAll(SELECTORS.searchDetails).forEach(patchDetailsSearch);

    document.querySelectorAll('predictive-search, search-modal').forEach(patchNativeCustomElement);

    document.querySelectorAll(SELECTORS.searchInput).forEach(patchSearchInput);
  }

  function init() {
    interceptFocusExpansion();
    processAll();

    var observer = new MutationObserver(function (mutations) {
      var shouldProcess = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) shouldProcess = true;
        });
      });
      if (shouldProcess) processAll();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();